window.portalModule.factory 'PhrPatientService', ($rootScope, $log, $timeout, Restangular, AuthService, PracticeService, $q,  CacheFactory) ->
  $log = $log.getInstance('PhrPatientService')

  # Configuration
  # -----------------------------------

  timeout = null
  pollingMS = 60000 # every minute

  restAngular = Restangular.withConfig (Configurer) ->
    # configure the Restangular object here
    Configurer.setBaseUrl(AuthService.getConfigData().PHR_PATIENT_ENDPOINT_URL)

  _phrPatientService = restAngular.all("")

  # Service calls
  # -----------------------------------

  # set up a polling method to update isPPRAEnabled
  $rootScope.pollAndUpdatePhrPatients = ->
    $timeout.cancel(timeout)
    timeout = $timeout ->
      # get new phrPatients and update the DataStoreService
      _phrPatientService.get('phr_patients').then (response) ->
        $log.log 'pollAndUpdatePhrPatients', response.data
        $rootScope.DS.setPhrPatients(response.data) unless _.isEmpty(response.data)
        $rootScope.pollAndUpdatePhrPatients()
    , pollingMS
    return

  getPhrPatients: ->
    $q.all([
      _phrPatientService.get('phr_patients')
      PracticeService.getPractices()
    ]).then ([patientsResponse, practicesResponse]) ->
      phrPatients = patientsResponse?.data or []
      practicesList = if _.isArray(practicesResponse) then practicesResponse else _.values(practicesResponse)
      practicesByGuid = _.keyBy _.filter(practicesList, (practice) -> practice?.practice_guid?),
        (practice) -> practice.practice_guid.toLowerCase()

      # collect practice GUIDs still visible in Patient Fusion: not FMH-onboarded and not retired
      visiblePracticeGuids = _.map _.filter(practicesList, (practice) ->
        practice? and practice.is_fmh_onboarding_completed is false and practice.is_patient_fusion_retired isnt true
      ), (practice) -> practice.practice_guid?.toLowerCase()

      # keep only PHR patients linked to those practices
      filteredPatients = _.filter(phrPatients, (phrPatient) ->
        practiceGuidsForPatient = _.map(phrPatient.patientPractices or [], (patientPractice) ->
          patientPractice.practiceGuid?.toLowerCase()
        )
        _.some(practiceGuidsForPatient, (practiceGuid) -> _.includes(visiblePracticeGuids, practiceGuid))
      )

      # practices the patient holds records at that have left Patient Fusion.
      # Read from each practice's own flags rather than from what the filter
      # rejected, so a practice missing from the lookup is never mistaken for a
      # departed one.
      linkedPracticeGuids = _.uniq _.compact _.flatten _.map phrPatients, (phrPatient) ->
        _.map (phrPatient.patientPractices or []), (patientPractice) ->
          patientPractice.practiceGuid?.toLowerCase()

      departedPractices = _.filter _.map(linkedPracticeGuids, (practiceGuid) -> practicesByGuid[practiceGuid]),
        (practice) ->
          practice? and (practice.is_patient_fusion_retired is true or practice.is_fmh_onboarding_completed is true)

      { data: filteredPatients, departedPractices: departedPractices }

  getPatientPractices: ->
    _phrPatientService.get('patient_practices').then (response) ->
      _.keyBy response.data, (patientPractice) ->
        patientPractice.patientPracticeGuid.toLowerCase()

  get: (phrPatientGuid) ->
    return _phrPatientService.one('phr_patients', phrPatientGuid).get()

# example phr_patients response
#{
#   "data": [{
#    "firstName": "Fargo",
#    "lastName": "MacFargo",
#    "patientPractices": [
#        {
#            "isPpraEnabled": false,
#            "patientPracticeGuid": "7C3ED16D-B048-4C8D-B8AD-8306B240A7A0",
#            "practiceGuid": "FBF238A3-D39B-4AB8-9549-147666B4E92E"
#        }
#    ],
#    "phrPatientGuid": "73BAA0E7-56F5-496E-8E02-06AE7D1468DB"
#   }]
#}

# example phr_patients/:guid response
#{
#    "data": {
#        "dateOfBirth": "1954-04-14",
#        "ethnicityName": "Not Hispanic or Latino",
#        "firstName": "Fargo",
#        "languageName": null,
#        "lastName": "MacFargo",
#        "patientPractices": [
#            {
#                "patientPracticeGuid": "7C3ED16D-B048-4C8D-B8AD-8306B240A7A0",
#                "practiceGuid": "FBF238A3-D39B-4AB8-9549-147666B4E92E"
#            }
#        ],
#        "phrPatientGuid": "73BAA0E7-56F5-496E-8E02-06AE7D1468DB",
#        "raceNames": "White"
#    }
#}
